import { Component, OnInit } from '@angular/core';
import { BreadCrumbModel , BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components';
import { Router, ActivatedRoute } from '@angular/router';
import { BREADCRUMBS } from 'config';
import { FaqService } from './faq.service';
import { AccordionComponent } from './../../ui-components/accordion/accordion.component';
@Component({
  selector: 'app-faq',
  providers: [FaqService],
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {
  faqDetails: any;
  constructor(private breadCrumbService: BreadCrumbService, private faqservice: FaqService) {
      this.faqDetails = [];
   }

  ngOnInit() {
    document.title = 'FAQ';
    this.breadCrumbService.setCurrentBreadCrumb({ label: 'Frequently Asked Questions', routerLink: '/faq' });
    this.faqservice.getFaqDetails().subscribe(response => {
      console.log(response);
      this.faqDetails = response; // make it FAQ Details
      console.log(this.faqDetails.faq.length);
    });
  }
 }

